<script lang="ts">
    import type { TopInfo } from '@shared/types/types';

    interface Props {
        infos: TopInfo[] | undefined;
        variant?: 'standard' | 'clean';
    }

    let { infos, variant = 'standard' }: Props = $props();
</script>

{#if infos?.length}
    <dl
        class={[
            'reptile-top-info',
            {
                'reptile-top-info--clean': variant === 'clean',
            },
        ]}
    >
        {#each infos.slice(0, 3) as info (info)}
            <div class="reptile-top-info__item">
                <dd
                    class={[
                        'reptile-top-info__value',
                        {
                            'reptile-top-info__value--clean': variant === 'clean',
                        },
                    ]}
                >
                    {info.value}
                </dd>
                <dt class="reptile-top-info__label">{info.label}</dt>
            </div>
        {/each}
    </dl>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    /**
 *
 *
 *
 */
    .reptile-top-info {
        border-top: tokens.$oc-semantic-border-width-100 solid tokens.$oc-semantic-color-background-disabled;
        border-bottom: tokens.$oc-semantic-border-width-100 solid tokens.$oc-semantic-color-background-disabled;
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-absolute-25;
        font: tokens.$oc-semantic-font-copy-75;
        padding-top: tokens.$oc-semantic-spacing-absolute-50;
        padding-bottom: tokens.$oc-semantic-spacing-absolute-50;

        &__item {
            @include mixins.ellipsis(nowrap);
        }

        &__label,
        &__value {
            display: inline;
        }

        &__value {
            font-weight: tokens.$oc-base-font-weight-bold;

            &--clean {
                font-weight: tokens.$oc-base-font-weight-regular;
                color: tokens.$oc-semantic-color-text-default;
            }
        }

        &--clean {
            border: none;
        }
    }
</style>
